import { lazy, type ComponentType, type ComponentProps, type FC } from 'react';
import { useImportCaptureReport } from './ImportCapture.tsx';

/**
 * This helper allows us to dynamically import a component but still be able to render it on the server side.
 * NOTE: if we use the same 'webpackChunkName: ".."' magic comment for different dynamic imports, they will be
 * bundled together. This is useful when we want to bundle A/B test or feature flag related components together.
 * @param chunkName needs to be the same chunk name that we use in the webpack magic comment
 * @param factory function that returns a dynamic import with default export
 * @returns lazy component that can be rendered on the server side
 */
export function dibsLazy<T extends ComponentType<$TSFixMe>>(
    chunkName: string,
    factory: () => Promise<{ default: T }>
): FC<ComponentProps<T>> {
    const Component = lazy(factory);

    const DibsLazy: FC<ComponentProps<T>> = props => {
        useImportCaptureReport(chunkName);
        return <Component {...props} />;
    };

    return DibsLazy;
}
